import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiPlus } from 'react-icons/fi';
import { toast } from 'react-toastify';
import BudgetList from '../../components/Budgets/BudgetList';
import budgetService from '../../services/budgetService';
import projectService from '../../services/projectService';

const Budgets = () => {
  const [budgets, setBudgets] = useState([]);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({});

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async (appliedFilters = {}) => {
    setLoading(true);
    try {
      const [budgetsData, projectsData] = await Promise.all([
        budgetService.getAllBudgets(appliedFilters),
        projectService.getAllProjects()
      ]);
      setBudgets(budgetsData.data || []);
      setProjects(projectsData.projects || []);
      setFilters(appliedFilters);
    } catch (error) {
      console.error('Error loading data:', error);
      toast.error('Failed to load budgets');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await budgetService.deleteBudget(id);
      toast.success('Budget deleted successfully');
      loadData(filters);
    } catch (error) {
      console.error('Error deleting budget:', error);
      toast.error(error.response?.data?.error || 'Failed to delete budget');
    }
  };

  const handleRefresh = (newFilters) => {
    loadData(newFilters);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-gray-500">Loading budgets...</div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Budgets</h1>
          <p className="text-gray-600 mt-1">Manage project budgets and track spending</p>
        </div>
        <Link
          to="/app/budgets/new"
          className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          <FiPlus className="mr-2" />
          New Budget
        </Link>
      </div>

      <BudgetList
        budgets={budgets}
        projects={projects}
        onDelete={handleDelete}
        onRefresh={handleRefresh}
      />
    </div>
  );
};

export default Budgets;

